module.exports = __webpack_public_path__ + "images/65d468268a1bccea552942beb2e92314.svg";